const LINKEDIN = "https://www.linkedin.com/in/iambaishali/";
const EMAIL = "heybaishali@gmail.com";

const links = [
  { label: "How it works", href: "#how-it-works" },
  { label: "About", href: "#about" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#060607] border-t border-[#F3F0E8]/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <p data-testid="footer-brand" className="font-serif-d font-black tracking-tight text-3xl text-[#F3F0E8]">
              CtrlB<span className="text-[#118C4F]">.</span>
            </p>
            <p className="text-sm text-[#F3F0E8]/50 mt-3">LinkedIn &amp; Personal Brand Growth</p>
          </div>
          <nav aria-label="Footer" data-testid="footer-links" className="grid grid-cols-2 gap-x-8 gap-y-3">
            {links.map((l) => (
              <a key={l.href} href={l.href} className="text-sm lowercase tracking-wide text-[#F3F0E8]/55 hover:text-[#F3F0E8] transition-colors w-fit">
                {l.label}
              </a>
            ))}
          </nav>
          <div className="flex flex-col gap-3 md:items-end">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email-link"
              className="text-xs tracking-[0.15em] text-[#F3F0E8]/55 hover:text-[#CFE9EF] transition-colors"
            >
              {EMAIL}
            </a>
            <a
              href={LINKEDIN}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="text-xs tracking-[0.15em] text-[#F3F0E8]/55 hover:text-[#CFE9EF] transition-colors"
            >
              linkedin.com/in/iambaishali
            </a>
          </div>
        </div>

        <p
          aria-hidden="true"
          className="font-serif-d font-black tracking-tighter leading-none text-outline text-[18vw] whitespace-nowrap text-center select-none mt-16 -mb-4"
        >
          CtrlB
        </p>

        <div className="border-t border-[#F3F0E8]/10 pt-6 mt-6 flex flex-col sm:flex-row justify-between gap-3">
          <p data-testid="footer-copyright" className="text-xs text-[#F3F0E8]/45">© 2026 CtrlB Consulting.</p>
          <p data-testid="footer-legal" className="text-[10px] uppercase tracking-[0.25em] text-[#F3F0E8]/35">
            Independent consultancy · Government of India registered business
          </p>
        </div>
      </div>
    </footer>
  );
}
